// src/utils/apiClient.js
// بديل شبه مطابق لـ fetch() نفسها - نفس التوقيع بالضبط (url, options) - يضيف
// فقط ترويسة Authorization: Bearer <idToken> تلقائياً إذا كان المستخدم مسجّل
// دخول. الـtoken يُجلب حياً من جلسة Firebase Auth (auth.currentUser.getIdToken())
// بدل نص ثابت بـlocalStorage - الـSDK يجدده تلقائياً بالخلفية، فما ينتهي
// بصلاحية بعد ساعة وسط الاستخدام الطويل (Login.js يفتح هذي الجلسة عبر
// signInWithEmailAndPassword عند الدخول). لا يغيّر body ولا يتعامل مع
// الـresponse - يرجّع نفس كائن fetch() القياسي كما هو، حتى يبقى كل كود
// .json()/.ok الموجود بمكانه بدون أي تعديل.

import { auth } from "../firebase";

export const API_BASE =
  process.env.NODE_ENV === "development"
    ? "http://localhost:5000/api"
    : "https://artikaorder-backend.onrender.com/api";

// ⚠️ تصلح سالفة "Unauthorized: missing token" الخام اللي كانت تظهر أحياناً
// وسط الاستخدام: الواجهة تعتبر المستخدم مسجّل دخول بالاعتماد على
// localStorage.username فقط (راجع App.js)، لكن جلسة Firebase Auth الحقيقية
// مصدر مستقل ممكن تضيع (بيانات متصفح انمسحت، IndexedDB محظور، جلسة انتهت...)
// بدون ما يتغيّر localStorage - فيروح كل طلب بدون Authorization ويرجّع
// السيرفر هذا الخطأ الخام بمنتصف الشغل. هذا الفحص يكتشف الحالة قبل الإرسال
// ويرجّع المستخدم لتسجيل الدخول مباشرة بدل ما يوصله خطأ غير مفهوم.
let sessionExpiredHandled = false;

function handleExpiredSession() {
  if (sessionExpiredHandled) return;
  sessionExpiredHandled = true;

  localStorage.removeItem("username");
  localStorage.removeItem("uid");
  localStorage.removeItem("authToken");
  localStorage.removeItem("grantedDashboards");
  ["displayName", "loginName", "permissions", "dashboardType"].forEach((key) =>
    localStorage.removeItem(key)
  );

  window.alert("⚠️ انتهت جلسة الدخول، الرجاء تسجيل الدخول مرة أخرى");
  window.location.href = "/";
}

export async function apiFetch(input, options = {}) {
  const headers = { ...(options.headers || {}) };

  if (!headers.Authorization) {
    try {
      await auth.authStateReady();
      if (auth.currentUser) {
        const idToken = await auth.currentUser.getIdToken();
        headers.Authorization = `Bearer ${idToken}`;
      } else if (localStorage.getItem("username")) {
        // الواجهة تعتقد أن المستخدم مسجّل دخول لكن جلسة Firebase مفقودة -
        // نوقّف أي كود لاحق (Promise ما تنحل أبداً) لأن الصفحة بطريقها
        // للتحويل، حتى ما تظهر رسالة خطأ خام قبل اكتمال التحويل لصفحة الدخول.
        handleExpiredSession();
        return new Promise(() => {});
      }
    } catch (err) {
      console.error("Failed to get fresh auth token:", err);
    }
  }

  return fetch(input, { ...options, headers });
}
